import Editor from './editor';
import md from '../../../const/meta/documents';

export default {
  Editor,
  md: md.calculationofpayments,
};
